// Icon components with SVG animations
import React from 'react';

export const AutomationIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="38" fill="url(#gradient1)" opacity="0.1"/>
    <circle cx="40" cy="40" r="30" stroke="url(#gradient1)" strokeWidth="2" fill="none">
      <animate attributeName="r" values="28;32;28" dur="3s" repeatCount="indefinite"/>
      <animate attributeName="opacity" values="1;0.5;1" dur="3s" repeatCount="indefinite"/>
    </circle>
    <path d="M40 20L45 28H35L40 20Z" fill="#0071e3">
      <animateTransform attributeName="transform" type="rotate" from="0 40 40" to="360 40 40" dur="10s" repeatCount="indefinite"/>
    </path>
    <rect x="28" y="35" width="24" height="18" rx="3" fill="#0071e3" opacity="0.8"/>
    <circle cx="34" cy="44" r="3" fill="#fff">
      <animate attributeName="opacity" values="0.5;1;0.5" dur="2s" repeatCount="indefinite"/>
    </circle>
    <circle cx="46" cy="44" r="3" fill="#fff">
      <animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite"/>
    </circle>
    <path d="M35 55L40 58L45 55" stroke="#0071e3" strokeWidth="2" strokeLinecap="round"/>
    <defs>
      <linearGradient id="gradient1" x1="0" y1="0" x2="80" y2="80">
        <stop offset="0%" stopColor="#0071e3"/>
        <stop offset="100%" stopColor="#bf5af2"/>
      </linearGradient>
    </defs>
  </svg>
);

export const AIAnalyticsIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="38" fill="url(#gradient2)" opacity="0.1"/>
    <rect x="20" y="45" width="8" height="20" rx="2" fill="#0071e3">
      <animate attributeName="height" values="20;28;20" dur="2s" repeatCount="indefinite"/>
      <animate attributeName="y" values="45;37;45" dur="2s" repeatCount="indefinite"/>
    </rect>
    <rect x="32" y="35" width="8" height="30" rx="2" fill="#bf5af2">
      <animate attributeName="height" values="30;35;30" dur="2.5s" repeatCount="indefinite"/>
      <animate attributeName="y" values="35;30;35" dur="2.5s" repeatCount="indefinite"/>
    </rect>
    <rect x="44" y="25" width="8" height="40" rx="2" fill="#0071e3">
      <animate attributeName="height" values="40;45;40" dur="3s" repeatCount="indefinite"/>
      <animate attributeName="y" values="25;20;25" dur="3s" repeatCount="indefinite"/>
    </rect>
    <rect x="56" y="38" width="8" height="27" rx="2" fill="#bf5af2">
      <animate attributeName="height" values="27;32;27" dur="2.2s" repeatCount="indefinite"/>
      <animate attributeName="y" values="38;33;38" dur="2.2s" repeatCount="indefinite"/>
    </rect>
    <circle cx="40" cy="20" r="4" fill="#30d158">
      <animate attributeName="opacity" values="0.3;1;0.3" dur="2s" repeatCount="indefinite"/>
    </circle>
    <defs>
      <linearGradient id="gradient2" x1="0" y1="0" x2="80" y2="80">
        <stop offset="0%" stopColor="#bf5af2"/>
        <stop offset="100%" stopColor="#0071e3"/>
      </linearGradient>
    </defs>
  </svg>
);

export const IoTIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="38" fill="url(#gradient3)" opacity="0.1"/>
    <circle cx="40" cy="40" r="6" fill="#0071e3">
      <animate attributeName="r" values="6;8;6" dur="2s" repeatCount="indefinite"/>
    </circle>
    <circle cx="25" cy="25" r="5" fill="#bf5af2" opacity="0.8">
      <animate attributeName="opacity" values="0.8;1;0.8" dur="1.5s" repeatCount="indefinite"/>
    </circle>
    <circle cx="55" cy="25" r="5" fill="#30d158" opacity="0.8">
      <animate attributeName="opacity" values="0.8;1;0.8" dur="1.8s" repeatCount="indefinite"/>
    </circle>
    <circle cx="55" cy="55" r="5" fill="#bf5af2" opacity="0.8">
      <animate attributeName="opacity" values="0.8;1;0.8" dur="2.2s" repeatCount="indefinite"/>
    </circle>
    <circle cx="25" cy="55" r="5" fill="#30d158" opacity="0.8">
      <animate attributeName="opacity" values="0.8;1;0.8" dur="2.5s" repeatCount="indefinite"/>
    </circle>
    <path d="M40 40 L25 25" stroke="#0071e3" strokeWidth="2" strokeDasharray="2,2">
      <animate attributeName="stroke-dashoffset" values="0;4;0" dur="3s" repeatCount="indefinite"/>
    </path>
    <path d="M40 40 L55 25" stroke="#0071e3" strokeWidth="2" strokeDasharray="2,2">
      <animate attributeName="stroke-dashoffset" values="0;4;0" dur="3s" repeatCount="indefinite"/>
    </path>
    <path d="M40 40 L55 55" stroke="#0071e3" strokeWidth="2" strokeDasharray="2,2">
      <animate attributeName="stroke-dashoffset" values="0;4;0" dur="3s" repeatCount="indefinite"/>
    </path>
    <path d="M40 40 L25 55" stroke="#0071e3" strokeWidth="2" strokeDasharray="2,2">
      <animate attributeName="stroke-dashoffset" values="0;4;0" dur="3s" repeatCount="indefinite"/>
    </path>
    <defs>
      <linearGradient id="gradient3" x1="0" y1="0" x2="80" y2="80">
        <stop offset="0%" stopColor="#30d158"/>
        <stop offset="100%" stopColor="#0071e3"/>
      </linearGradient>
    </defs>
  </svg>
);

export const MaintenanceIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="38" fill="url(#gradient4)" opacity="0.1"/>
    <path d="M35 25 L45 25 L48 35 L32 35 Z" fill="#0071e3" opacity="0.8"/>
    <rect x="30" y="35" width="20" height="25" rx="2" fill="#bf5af2" opacity="0.9"/>
    <circle cx="40" cy="47" r="3" fill="#fff">
      <animate attributeName="opacity" values="1;0.3;1" dur="2s" repeatCount="indefinite"/>
    </circle>
    <path d="M25 60 L55 60" stroke="#0071e3" strokeWidth="3" strokeLinecap="round"/>
    <rect x="35" y="20" width="10" height="8" rx="1" fill="#30d158">
      <animate attributeName="y" values="20;18;20" dur="1.5s" repeatCount="indefinite"/>
    </rect>
    <defs>
      <linearGradient id="gradient4" x1="0" y1="0" x2="80" y2="80">
        <stop offset="0%" stopColor="#bf5af2"/>
        <stop offset="100%" stopColor="#30d158"/>
      </linearGradient>
    </defs>
  </svg>
);

export const MonitoringIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="38" fill="url(#gradient5)" opacity="0.1"/>
    <rect x="20" y="25" width="40" height="28" rx="3" fill="#0071e3" opacity="0.9"/>
    <rect x="24" y="29" width="32" height="20" rx="1" fill="#1d1d1f"/>
    <path d="M26 42 L32 38 L38 43 L44 35 L50 39" stroke="#30d158" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round">
      <animate attributeName="stroke-dasharray" values="0,100;100,0" dur="3s" repeatCount="indefinite"/>
    </path>
    <rect x="35" y="53" width="10" height="4" rx="1" fill="#0071e3"/>
    <rect x="28" y="57" width="24" height="2" rx="1" fill="#bf5af2"/>
    <circle cx="52" cy="32" r="2" fill="#30d158">
      <animate attributeName="opacity" values="1;0.3;1" dur="1.5s" repeatCount="indefinite"/>
    </circle>
    <defs>
      <linearGradient id="gradient5" x1="0" y1="0" x2="80" y2="80">
        <stop offset="0%" stopColor="#0071e3"/>
        <stop offset="100%" stopColor="#30d158"/>
      </linearGradient>
    </defs>
  </svg>
);

export const MESIcon = () => (
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="40" cy="40" r="38" fill="url(#gradient6)" opacity="0.1"/>
    <rect x="25" y="20" width="30" height="38" rx="2" fill="#bf5af2" opacity="0.9"/>
    <rect x="29" y="26" width="6" height="6" rx="1" fill="#fff" opacity="0.8"/>
    <rect x="37" y="26" width="6" height="6" rx="1" fill="#fff" opacity="0.8"/>
    <rect x="45" y="26" width="6" height="6" rx="1" fill="#fff" opacity="0.8"/>
    <rect x="29" y="35" width="6" height="6" rx="1" fill="#fff" opacity="0.8"/>
    <rect x="37" y="35" width="6" height="6" rx="1" fill="#30d158">
      <animate attributeName="opacity" values="1;0.5;1" dur="2s" repeatCount="indefinite"/>
    </rect>
    <rect x="45" y="35" width="6" height="6" rx="1" fill="#fff" opacity="0.8"/>
    <rect x="29" y="44" width="6" height="6" rx="1" fill="#fff" opacity="0.8"/>
    <rect x="37" y="44" width="6" height="6" rx="1" fill="#fff" opacity="0.8"/>
    <rect x="45" y="44" width="6" height="6" rx="1" fill="#fff" opacity="0.8"/>
    <defs>
      <linearGradient id="gradient6" x1="0" y1="0" x2="80" y2="80">
        <stop offset="0%" stopColor="#bf5af2"/>
        <stop offset="100%" stopColor="#0071e3"/>
      </linearGradient>
    </defs>
  </svg>
);

export const IndustryIcon = ({ gradient = "gradient7" }) => (
  <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="50" cy="50" r="48" fill={`url(#${gradient})`} opacity="0.15"/>
    <circle cx="50" cy="50" r="35" stroke={`url(#${gradient})`} strokeWidth="2" opacity="0.5">
      <animate attributeName="r" values="35;38;35" dur="3s" repeatCount="indefinite"/>
    </circle>
    <defs>
      <linearGradient id={gradient} x1="0" y1="0" x2="100" y2="100">
        <stop offset="0%" stopColor="#0071e3"/>
        <stop offset="100%" stopColor="#bf5af2"/>
      </linearGradient>
    </defs>
  </svg>
);
